import { AxiosResponse } from 'axios'
import React, { SyntheticEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../App/Components/Button/Button'
import TextInput from '../../../App/Components/Form/TextInput/TextInput'
import Spinner from '../../../App/Components/Spinner/Spinner'
import LoginClient from '../Client/LoginClient'

interface Validation {
  optiosId: null | string
  email: null | string
  password: null | string
}

const Partner: React.FC = () => {
  const optiosIdParameter = new URLSearchParams(window.location.search).get(
    'optios_id',
  )
  const [optiosId, setOptiosId] = useState<string>(optiosIdParameter)
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [validation, setValidation] = useState<null | Validation>({
    optiosId: null,
    email: null,
    password: null,
  })
  const [loggingIn, setLoggingIn] = useState<boolean>(false)
  const { t } = useTranslation(['messages', 'security'])

  const onSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!validate(true)) {
      return
    }

    setLoggingIn(true)
    LoginClient.loginAsPartner(optiosId, email, password)
      .then((response: AxiosResponse) => {
        window.location.replace('/')
      })
      .catch(error => {
        const errorResponse = error.response.data.error
        setValidation({
          ...validation,
          password: t(
            'security;;' + errorResponse.message_key,
            errorResponse.message_data,
          ),
        })
        setLoggingIn(false)
      })
  }

  const validate = (validateAll: boolean = false): boolean => {
    const newValidation: Validation = {
      optiosId: null,
      email: null,
      password: null,
    }
    if (
      (validateAll || null !== validation.password) &&
      password.length === 0
    ) {
      newValidation.password = 'Password is required'
    }

    if ((validateAll || null !== validation.email) && email.length === 0) {
      newValidation.email = 'E-mail is required'
    }

    if (
      (validateAll || null !== validation.optiosId) &&
      optiosId.length === 0
    ) {
      newValidation.optiosId = 'Optios ID is required'
    }

    if (!Object.values(newValidation).every(field => field === null)) {
      setValidation(newValidation)
      return false
    }

    return true
  }

  useEffect(() => {
    validate()
  }, [email, password, optiosId])

  return (
    <>
      <h1>{t('Partner')}</h1>
      {loggingIn ? (
        <Spinner />
      ) : (
        <form onSubmit={onSubmit} method={'post'}>
          <TextInput
            label={'Optios ID'}
            onChange={(e: SyntheticEvent<HTMLInputElement>) =>
              setOptiosId(e.currentTarget.value)
            }
            value={optiosId}
            error={validation.optiosId}
          />
          <TextInput
            label={'E-mail'}
            onChange={(e: SyntheticEvent<HTMLInputElement>) =>
              setEmail(e.currentTarget.value)
            }
            value={email}
            error={validation.email}
            type="email"
            autocomplete="username"
          />
          <TextInput
            label={'Password'}
            onChange={(e: SyntheticEvent<HTMLInputElement>) =>
              setPassword(e.currentTarget.value)
            }
            value={password}
            error={validation.password}
            type={'password'}
          />
          <Button type={'submit'}>{t('Login')}</Button>
        </form>
      )}
    </>
  )
}

export default Partner
